import { render, staticRenderFns } from "./order-items.vue?vue&type=template&id=71bb1216"
import script from "./order-items.vue?vue&type=script&lang=ts"
export * from "./order-items.vue?vue&type=script&lang=ts"
import style0 from "./order-items.vue?vue&type=style&index=0&id=71bb1216&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71bb1216')) {
      api.createRecord('71bb1216', component.options)
    } else {
      api.reload('71bb1216', component.options)
    }
    module.hot.accept("./order-items.vue?vue&type=template&id=71bb1216", function () {
      api.rerender('71bb1216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/order-items.vue"
export default component.exports